import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { AngularEditorConfig } from "@kolkov/angular-editor";

import { AlertService, ShowroomService } from "../../_services";
import { Utils } from "../../_helpers";

@Component({ templateUrl: "showroom.edit.html" })
export class ShowroomEdit implements OnInit {
  heading = "Edit Showroom";
  subheading = "";
  icon = "fa fa-folder-o icon-gradient bg-happy-itmeo";
  showroomForm: FormGroup;
  loading = false;
  submitted = false;
  showroom_id: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private showroomService: ShowroomService,
    private alertService: AlertService
  ) {
    this.showroom_id = this.route.snapshot.params["id"];
  }

  ngOnInit() {
    this.getShowroom(this.showroom_id);
    this.showroomForm = this.formBuilder.group({
      showroom_name: ["", [Validators.required, Utils.noWhitespaceValidator]],
      status: ["", [Validators.required, Utils.noWhitespaceValidator]]
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.showroomForm.controls;
  }

  getShowroom(id) {
    this.showroomService.getById(id).subscribe((data: any) => {
      var showroom = data.result_set;
      this.showroomForm.setValue({
        showroom_name: showroom.showroom_name,
        status: showroom.status
      });
    });
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.showroomForm.invalid) {
      return;
    }

    this.loading = true;

    const formData = new FormData();
    formData.append("showroom_id", this.showroom_id);
    formData.append(
      "showroom_name",
      this.showroomForm.get("showroom_name").value
    );
    formData.append("status", this.showroomForm.get("status").value);

    this.showroomService
      .update(formData)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data.status == "ok") {
            this.alertService.success(data.message, true);
            this.router.navigate(["/showroom"]);
          } else {
            this.alertService.error(data.message, true);
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        }
      );
  }
}
